import { render } from "./PartnerSectionTwo.vue?vue&type=template&id=3c1d8a10"
import script from "./PartnerSectionTwo.vue?vue&type=script&lang=js"
export * from "./PartnerSectionTwo.vue?vue&type=script&lang=js"

import exportComponent from "/Users/larijuva/suha-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__